import {useEffect, useContext, useState, useMemo} from 'react';
import systemContext from "../../_context/systemContext";
import Spinner from 'react-bootstrap/Spinner';
import { Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap'
import { AiOutlinePartition, AiOutlineUser, AiOutlineMedium, AiOutlinePercentage } from "react-icons/ai";
import { BsArrowRight } from "react-icons/bs";
import '../../Bienvenida.css';

const Catalogos = () => { 
    const SystemContext = useContext(systemContext);
    const user = SystemContext.getUser();
     const { isManager, isProv, isComprasN } = useMemo(() => ({
        isManager: user && user.profile === 'Super',
        isProv: user && user.profile === 'Proveedor',
        isComprasN: user && user.profile === 'Compras'
    }), [user]);
    const [loading, setLoading] = useState(false);

    function LoaderModal({ show }) {
        return (
            <Modal show={show} backdrop="static"  keyboard={false} centered>
            <Modal.Body className="text-center">
                <Spinner animation="border" role="status" className="mb-3" />
                <h5>Cargando información...</h5>
            </Modal.Body>
            </Modal>
        );
    }

    return(
    <>
    <div className="nova-dashboard-balanced">
        {/* Grid de Tarjetas Balanceadas */}
        <div className="nova-grid-balanced">
            <Link to="/usuarios" className="nova-card-balanced">
                <div className="balanced-card-icon">
                    <AiOutlineUser />
                </div>
                <h3>Usuarios</h3>
                <p>Administración de usuarios</p>
                <div className="balanced-arrow">
                    <BsArrowRight />
                </div>
                <div className="balanced-hover-effect"></div>
            </Link>
            <Link to="/motivos" className="nova-card-balanced">
                <div className="balanced-card-icon">
                    <AiOutlineMedium />
                </div>
                <h3>Motivos de venta sin cargo</h3>
                <p>Gestión de motivos</p>
                <div className="balanced-arrow">
                    <BsArrowRight />
                </div>
                <div className="balanced-hover-effect"></div>
            </Link>
            <Link to="/segmentos" className="nova-card-balanced">
                <div className="balanced-card-icon">
                    <AiOutlinePartition />
                </div>
                <h3>Segmentos</h3>
                <p>Gestión de segmentos</p>
                <div className="balanced-arrow">
                    <BsArrowRight />
                </div>
                <div className="balanced-hover-effect"></div>
            </Link>
            <Link to="/porcentajes" className="nova-card-balanced">
                <div className="balanced-card-icon">
                    <AiOutlinePercentage />
                </div>
                <h3>Porcentajes de autorización</h3>
                <p>Porcentajes autorizados para los cálculos</p>
                <div className="balanced-arrow">
                    <BsArrowRight />
                </div>
                <div className="balanced-hover-effect"></div>
            </Link>
        </div>
    </div>
    </>
)
}

export default Catalogos;